export function getRealFontFamilyName(fontFamily) {
	return `'${fontFamily}'`;
}
